import Swiper from "swiper";
import { Navigation } from "swiper/modules";

function sliderProduct() {
  new Swiper(".search-dropdown__slider .swiper", {
    modules: [ Navigation ],
    spaceBetween: 40,
    slidesPerView: 2,
    navigation: {
      prevEl: '.search-dropdown__slider .swiper-button-prev',
      nextEl: '.search-dropdown__slider .swiper-button-next',
    },
  });
}
sliderProduct();